import { useTranslation } from 'react-i18next';
import { setLanguage } from '../../utils/language';

export function LanguageMenu() {
  const { t, i18n } = useTranslation();
  const active = i18n.language.startsWith('de') ? 'de' : 'en';

  return (
    <div className="language-pill" role="group" aria-label={t('language-switch-aria-label')}>
      <button
        type="button"
        className={`language-pill__option ${active === 'de' ? 'is-active' : ''}`}
        onClick={() => setLanguage('de')}
        aria-pressed={active === 'de'}
      >
        DE
      </button>
      <button
        type="button"
        className={`language-pill__option ${active === 'en' ? 'is-active' : ''}`}
        onClick={() => setLanguage('en')}
        aria-pressed={active === 'en'}
      >
        EN
      </button>
    </div>
  );
}
